<script>
export default {
    name: "VoucherDeductionsForm",

    data() {

        return {
            memo: ``,
            cDeduction: {
                voucherDeductionId: 0,
                deductionId: 0,
                deductionName: ``,
                rate: 0,
                deductionAmount: 0,
                userName: this.$root.username,
                isKra: false,
                useRate: 0,
                voucherAmount: 0,
                refNo: "",
            },
            kDeduction: {
                voucherDeductionId: 0,
                deductionId: 0,
                deductionName: ``,
                rate: 0,
                deductionAmount: 0,
                userName: this.$root.username,
                isKra: true,
                useRate: 0,
                voucherAmount: 0,
                refNo: "",
            },
        };
    },

    props: {

        showModal: Boolean,
        showCancel: {
            type: Boolean,
            default: true,
        },
        kraDeductions: Array,
        customDeductions: Array,
        voucherDetails: Object,
        consultant: Object,
        deductions: Array,
    },

    computed: {

        total() {

            if(!this.voucherDetails.voucherDetails.length) return 0;

            return this.voucherDetails.voucherDetails
                .map(voucherItem => parseFloat(voucherItem.voucherAmount))
                .reduce((sum,amt) => sum+amt);
        },

        totalDeductions() {

            if(!this.deductions.length) return 0;

            return this.deductions.map(ded => parseFloat(ded.deductionAmount))
                .reduce((sum,amt) => sum+amt);
        },

        totalKRADeductions() {
            if(!this.deductions.length) return 0;

            const deductions = this.deductions.filter(ded => ded.isKra);

            return deductions.length ? deductions.map(ded => parseFloat(ded.deductionAmount))
                .reduce((sum,amt) => sum+amt) : 0;
        },

        totalCustomDeductions() {
            if(!this.deductions.length) return 0;

            const deductions = this.deductions.filter(ded => !ded.isKra);

            return deductions.length ? deductions.map(ded => parseFloat(ded.deductionAmount))
                .reduce((sum,amt) => sum+amt) : 0;
        },

        netTotal() {
            
            return this.total - this.totalDeductions; 
        },

        deductionData() {

            return {
                voucherNo: this.$route.query.Voucher,
                voucherDeductions: this.deductions,
                saveMemo: this.memo,
                userName: this.$root.username,
            };
        },

        cancelDetails() {

            return {
                voucherNo: this.$route.query.Voucher,
                payeeID: this.consultant.id,
                payeeName: this.consultant.names,
                txnDate: window.moment().format(`YYYY-MM-DD`),
                userName: this.$root.username,
                memo: `-`,
                voucherPayDetails: this.voucherDetails.voucherDetails.map(item => ({
                    id: item.id,
                    invoiceDetailID: item.invoiceDetailID,
                    amountPaid: item.paid,
                })),
            };
        },
    },

    watch: {

        "cDeduction.deductionId"() {
            if(!this.cDeduction.deductionId) return;

            this.customDeductions.forEach(ded => {

                if(ded.deductionId==this.cDeduction.deductionId) {
                    this.cDeduction.deductionName=ded.deductionName;
                }
            });
        },

        "cDeduction.useRate"() {
            if(this.cDeduction.useRate == 0) return;

            this.customDeductions.forEach(ded => {

                if(ded.deductionId==this.cDeduction.deductionId && this.cDeduction.useRate == 1) {
                    this.cDeduction.rate=ded.defaultRate;
                }
                if(ded.deductionId==this.cDeduction.deductionId && this.cDeduction.useRate == 2) {
                    this.cDeduction.rate=0;
                    this.cDeduction.deductionAmount=ded.defaultValue;
                }
            })            
        },

        "cDeduction.rate"() {
            if(!this.cDeduction.rate) return;

            this.cDeduction.deductionAmount=Math.round((parseFloat(this.cDeduction.rate)*this.total)/100);
        },

        "kDeduction.deductionId"() {
            if(!this.kDeduction.deductionId) return;

            this.kraDeductions.forEach(ded => {

                if(ded.deductionId==this.kDeduction.deductionId) {
                    this.kDeduction.deductionName=ded.deductionName;
                    
                }
            })
        },

        "kDeduction.useRate"() {
            if(this.kDeduction.useRate == 0) return;

            this.kraDeductions.forEach(ded => {

                if(ded.deductionId==this.kDeduction.deductionId && this.kDeduction.useRate == 1) {
                    this.kDeduction.rate=ded.defaultRate;  
                }
                if(ded.deductionId==this.kDeduction.deductionId && this.kDeduction.useRate == 2) {
                    this.kDeduction.rate=0;
                    this.kDeduction.deductionAmount=ded.defaultValue;  
                }
            });          
        },

        "kDeduction.rate"() {
            if(!this.kDeduction.rate) return;

            this.kDeduction.deductionAmount=Math.round((parseFloat(this.kDeduction.rate)*this.total)/100);
        },
    },

    methods: {

        completeVoucherCreation() {
            if(!window.confirm('Confirm Complete creating Voucher')) return;

            this.$root.loading=true;
            this.$http.post(`Finance/SaveConsultantPaymentVoucher`, this.deductionData)
                .then(response => {
                     this.$emit(`refresh`);
                     this.$router.push({name: ``});
                     this.$root.loading=false;
                     this.$emit(`closeModal`);
                    window.Swal.fire({ type: `success`, text: response.data.message,});
                }).catch(() => {this.$root.loading=false;});
        },

        cancelVoucher() {
            if(!window.confirm('Confirm Cancel voucher')) return;

            this.$root.loading=true;
            this.$http.post(`Finance/CancelPaymentVoucher`, this.cancelDetails).then(() => {
                this.$emit(`refresh`);
                this.$emit(`closeModal`);
                this.$root.loading=false;
                this.$router.push({name: ``});
            }).catch(() => {this.$root.loading=false;});
        }, CloseVoucher() {
            
              this.$emit(`refresh`);
                this.$emit(`closeModal`);
                 this.$router.push({name: ``});
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-3/4 w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-base">Complete Voucher: Add Deductions</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full flex flex-wrap p-3 bg-gray-200">
            <div class="flex-1">
                <h5 class="text-base font-medium">Consultant: {{consultant.names}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Contact: {{consultant.phoneno || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Reg No: {{consultant.practioninG_NO || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Qualification: {{consultant.speciality || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">KRA PIN:   {{consultant.krapinNo}}</h5>
            </div>
        </div>
        <div class="w-full p-3 text-center my-1">
            <h5 class="text-lg uppercase">Voucher NO: 
                {{$route.query.Voucher}}</h5>
        </div>
        <table class="table">
            <thead class="bg-blue-500 font-medium text-sm text-white">
                <tr class="w-full flex">
                    <th class="flex-1 p-tiny">Bill Date</th>
                    <th class="flex-1 p-tiny">Item</th>
                    <th class="flex-1 p-tiny">Patient</th>
                    <th class="flex-1 p-tiny">Qty</th>
                    <th class="flex-1 p-tiny text-right">Balance</th>
                    <th class="flex-1 p-tiny text-right">Voucher Amt</th>
                </tr>
            </thead>
            <tbody class="flex flex-col items-center text-sm bg-gray-100 overflow-auto">
                <tr class="w-full flex" v-for="(voucherItem,idx) in voucherDetails.voucherDetails" 
                :key="`voucher_${idx}`">
                    <td class="flex-1 p-tiny">{{voucherItem.billDate | dateFormat}}</td>
                    <td class="flex-1 p-tiny">{{voucherItem.itemName}}</td>
                    <td class="flex-1 p-tiny">{{voucherItem.patientName}}</td>
                    <td class="flex-1 p-tiny">{{voucherItem.quantity}}</td>
                    <td class="flex-1 p-tiny text-right">{{voucherItem.grandTotal | numberFormat}}</td>
                    <td class="flex-1 p-tiny text-right">{{voucherItem.voucherAmount | numberFormat}}</td>
                </tr>
                <tr class="w-full flex">
                    <th colspan="4" class="flex-1 p-1"></th>
                    <th class="flex-1 p-tiny text-right text-base">
                        Total: {{total | numberFormat}}
                    </th>
                </tr>
                <tr class="w-full flex">
                    <th colspan="6" class="flex-1 p-1 text-base">
                        Custom Deductions
                    </th>
                </tr>
                <tr class="w-full flex">
                    <th class="flex-1 p-1">
                        Deduction
                    </th>
                    <th class="flex-1 p-1">
                        Use Rate/Value
                    </th>
                    <th class="flex-1 p-1">
                        Rate
                    </th>
                    <th class="flex-1 p-1">
                        Value
                    </th>
                    <th class="flex-1 p-1">
                        Ref
                    </th>
                    <th class="flex-1 p-1">
                        Add
                    </th>
                </tr>
                <tr class="w-full flex">
                    <td class="p-1 flex-1">
                        <tail-select>
                            <template v-slot:field>
                                <select v-model="cDeduction.deductionId" 
                                    class="input-control input-sm text-xs">
                                    <option :value="0">Select deduction</option>
                                    <option 
                                        v-for="customDeduction in customDeductions" 
                                        :value="customDeduction.deductionId" 
                                        :key="customDeduction.deductionId">
                                            {{customDeduction.deductionName}}</option>
                                </select>
                            </template>
                        </tail-select>
                    </td>
                    <td class="p-1 flex-1">
                        <tail-select>
                            <template v-slot:field>
                                <select v-model="cDeduction.useRate" 
                                    class="input-control input-sm text-xs">
                                    <option :value="0">Select</option>
                                    <option :value="1">Rate</option>
                                    <option :value="2">Value</option>
                                </select>
                            </template>
                        </tail-select>
                    </td>
                    <td class="p-1 flex-1">
                        <input type="number" v-model.number="cDeduction.rate"
                            :disabled="cDeduction.useRate!=1" 
                            class="input-control input-sm text-xs text-right">
                    </td>
                    <td class="p-1 flex-1">
                        <input type="number" v-model.number="cDeduction.deductionAmount" 
                            :disabled="cDeduction.useRate!=2" 
                            class="input-control input-sm text-xs text-right">
                    </td>
                    <td class="p-1 flex-1">
                        <input type="text" v-model.trim="cDeduction.refNo"
                            class="input-control input-sm text-xs text-right">
                    </td>
                    <td class="p-1 flex-1">
                        <button @click.prevent="() => {
                            if(!cDeduction.deductionId) return;

                                deductions.push({
                                    ...cDeduction, voucherAmount: total, 
                                    voucherNo: $route.query.Voucher,
                                });
                                cDeduction={
                                    voucherDeductionId: 0,
                                    deductionId: 0,
                                    deductionName: ``,
                                    rate: 0,
                                    deductionAmount: 0,
                                    userName: $root.username,
                                    isKra: false,
                                    useRate: 0,
                                    refNo: ``
                                };
                            }"
                            class="btn-sm btn-primary text-xs rounded">
                                <i class="fa fa-plus"></i> Deduction</button>
                    </td>
                </tr>
                <tr class="w-full flex" 
                    v-for="(ded,idx) in deductions.filter(ded => !ded.isKra)" :key="`notkra_${idx}`">
                    <td class="flex-1 p-tiny">{{ded.deductionName}}</td>
                    <td class="flex-1 p-tiny">-</td>
                    <td class="flex-1 p-tiny">{{ded.rate}}</td>
                    <td class="flex-1 p-tiny">{{ded.deductionAmount}}</td>
                    <td class="flex-1 p-tiny">{{ded.refNo}}</td>
                    <td class="flex-1 p-tiny">
                        <button @click.prevent="() => {
                             cDeduction=ded
                             $emit('deleteDeduction', deductions.indexOf(ded))
                            }"
                            class="btn-sm btn-primary text-xs rounded m-px">
                                <i class="fa fa-pen"></i> Edit</button>
                        <button @click.prevent="$emit('deleteDeduction', deductions.indexOf(ded))"
                            class="btn-sm btn-danger text-xs rounded m-px">
                                <i class="fa fa-trash"></i> Remove</button>
                    </td>
                </tr>
                <tr class="w-full flex">
                    <th colspan="4" class="flex-1 p-1"></th>
                    <th class="flex-1 p-tiny text-right text-base">
                        Total Custom Deductions: {{totalCustomDeductions | numberFormat}}
                    </th>
                </tr>
                <tr class="w-full flex">
                    <th colspan="5" class="flex-1 p-1 text-base">
                        KRA Deductions
                    </th>
                </tr>
                <tr class="w-full flex">
                    <td class="p-1 flex-1">
                        <tail-select>
                            <template v-slot:field>
                                <select v-model="kDeduction.deductionId" 
                                    class="input-control input-sm text-xs">
                                    <option :value="0">Select deduction</option>
                                    <option 
                                        v-for="kraDeduction in kraDeductions" 
                                        :value="kraDeduction.deductionId" 
                                        :key="kraDeduction.deductionId">{{kraDeduction.deductionName}}</option>
                                </select>
                            </template>
                        </tail-select>
                    </td>
                    <td class="p-1 flex-1">
                        <tail-select>
                            <template v-slot:field>
                                <select v-model="kDeduction.useRate"
                                    class="input-control input-sm text-xs">
                                    <option :value="0">Select</option>
                                    <option :value="1">Rate</option>
                                    <option :value="2">Value</option>
                                </select>
                            </template>
                        </tail-select>
                    </td>
                    <td class="p-1 flex-1">
                        <input type="number" :disabled="kDeduction.useRate!=1"
                            v-model.number="kDeduction.rate"
                            class="input-control input-sm text-xs text-right">
                    </td>
                    <td class="p-1 flex-1">
                        <input type="number" :disabled="kDeduction.useRate!=2" 
                            v-model.number="kDeduction.deductionAmount"
                            class="input-control input-sm text-xs text-right">
                    </td>
                    <td class="p-1 flex-1">
                        <input type="text" v-model.trim="kDeduction.refNo"
                            class="input-control input-sm text-xs text-right">
                    </td>
                    <td class="p-1 flex-1">
                        <button @click.prevent="() => {
                                if(!kDeduction.deductionId) return;

                                deductions.push({
                                    ...kDeduction, voucherAmount: total, 
                                    voucherNo: $route.query.Voucher,
                                });
                                kDeduction={
                                    voucherDeductionId: 0,
                                    deductionId: 0,
                                    deductionName: ``,
                                    rate: 0,
                                    deductionAmount: 0,
                                    userName: $root.username,
                                    isKra: true,
                                    useRate: 0,
                                    refNo: ``
                                };
                            }"
                            class="btn-sm btn-primary text-xs rounded">
                                <i class="fa fa-plus"></i> Deduction</button>
                    </td>
                </tr>
                <tr class="w-full flex" 
                    v-for="(ded,idx) in deductions.filter(ded => ded.isKra)" :key="`custom_${idx}`">
                    <td class="flex-1 p-tiny">{{ded.deductionName}}</td>
                    <td class="flex-1 p-tiny">-</td>
                    <td class="flex-1 p-tiny">{{ded.rate}}</td>
                    <td class="flex-1 p-tiny">{{ded.deductionAmount | numberFormat}}</td>
                    <td class="flex-1 p-tiny">{{ded.refNo}}</td>
                    <td class="flex-1 p-tiny">
                        <button @click.prevent="() => {
                                kDeduction=ded;
                                $emit('deleteDeduction', deductions.indexOf(ded))
                            }" class="btn-sm btn-primary text-xs rounded m-px">
                              <i class="fa fa-pen"></i> Edit</button>
                        <button @click.prevent="$emit('deleteDeduction', deductions.indexOf(ded))"
                            class="btn-sm btn-danger text-xs rounded m-px">
                                <i class="fa fa-trash"></i> Remove</button>
                    </td>
                </tr>
                <tr class="w-full flex">
                    <th colspan="4" class="flex-1 p-1"></th>
                    <th class="flex-1 p-tiny text-right text-base">
                        Total KRA Deductions: {{totalKRADeductions | numberFormat}}
                    </th>
                </tr>
            </tbody>
            <tfoot class="flex flex-col items-center bg-gray-100">
                <tr class="w-full flex">
                    <th colspan="4" class="flex-1 p-1"></th>
                    <th class="flex-1 p-tiny text-right text-base">
                        Net Total: {{netTotal | numberFormat}}
                    </th>
                </tr>
            </tfoot>
        </table>
        <div class="w-full p-2">
            <label for="grid-memo" class="label-control">Memo:</label>
            <textarea v-model.trim="memo" id="grid-memo" cols="30" rows="3" 
                class="input-sm text-sm input-control"></textarea>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button @click.prevent="CloseVoucher"
        class="btn-danger btn-sm text-xs rounded mr-6">
            <i class="fa fa-times"></i> Close</button>
    <button
        @click.prevent="cancelVoucher" 
        class="btn-danger btn-sm text-xs rounded mr-6">
            <i class="fa fa-times"></i> Cancel Voucher</button>
    <button @click.prevent="completeVoucherCreation"
        class="btn-primary btn-sm text-xs rounded">
            <i class="fa fa-save"></i> Save Deductions</button>
  </template>
</tail-modal>
</template>
<style scoped>
.h-70 {
    max-height: 30rem;
}
</style>
